export default {
    topics: [
        {
            title: ' ClearFolder ',
            href: 'sm-recipient-ClearFolder.html',
            attributes: { 'data-id': 'sm-recipient-ClearFolder' },
            menu: { hasChildren: false },
            tocID: 'sm-recipient-ClearFolder-d66e3631',
            topics: [],
        },
        {
            title: ' ClearGroup ',
            href: 'sm-recipient-ClearGroup.html',
            attributes: { 'data-id': 'sm-recipient-ClearGroup' },
            menu: { hasChildren: false },
            tocID: 'sm-recipient-ClearGroup-d66e3639',
            topics: [],
        },
        {
            title: ' RegisterGroup ',
            href: 'sm-recipient-RegisterGroup.html',
            attributes: { 'data-id': 'sm-recipient-RegisterGroup' },
            menu: { hasChildren: false },
            tocID: 'sm-recipient-RegisterGroup-d66e3647',
            topics: [],
        },
        {
            title: ' RegisterGroup2 ',
            href: 'sm-recipient-RegisterGroup2.html',
            attributes: { 'data-id': 'sm-recipient-RegisterGroup2' },
            menu: { hasChildren: false },
            tocID: 'sm-recipient-RegisterGroup2-d66e3655',
            topics: [],
        },
    ],
};

